<template>
  <div class="datepicker">
    <v-date-picker locale="da-DK" :attributes="attributes" :masks="{ input: 'D. MMMM YYYY', weekdays: 'WW' }" show-weeknumbers trim-weeks :min-date="minDate" :max-date="maxDate" :is-range="range" v-model="dateSelected">
      <template v-slot="{ inputValue, inputEvents }">
        <label :for="id"><slot /></label>
        <input type="text" :id="id" :required="required" :value="inputValue" :aria-describedby="ariaDescribedBy ? ariaDescribedBy : null" v-on="inputEvents" />
      </template>
    </v-date-picker>
  </div>
</template>

<script>
import VDatePicker from 'v-calendar/src/components/DatePicker.vue'

export default {
    name: 'BaseDatePicker',
    components: {
        VDatePicker
    },
    model: {
        prop: 'value',
        event: 'input'
    },
    props: {
        id: {
            type: String
        },
        value: {
            type: [Date, String, Number, null],
            default: null
        },
        date: {
            type: Date
        },
        required: {
            type: Boolean
        },
        minDate: {
            type: [Date, String],
            default: null
        },
        maxDate: {
            type: [Date, String],
            default: null
        },
        range: {
            type: Boolean,
            default: false
        },
        ariaDescribedBy: {
            type: String
        }
    },
    data () {
        return {
            attributes: [{
                bar: true,
                key: 'today',
                dates: new Date()
            }],
            dateSelected: this.getInitialDate()
        }
    },
    watch: {
        value: {
            handler (newValue) {
                this.dateSelected = this.normalizeDate(newValue)
            },
            immediate: true
        },
        date (newValue) {
            if (this.value === null || this.value === undefined) {
                this.dateSelected = this.normalizeDate(newValue)
            }
        },
        dateSelected (newValue) {
            this.$emit('input', newValue ? newValue.toISOString() : null)
        }
    },
    mounted () {
        if (!this.$slots.hasOwnProperty('default') || (this.$slots.hasOwnProperty('default') && this.$slots.default.some(property => property.elm && property.elm.nodeName === '#text' && property.text.trim() === ''))) {
            // IS FALSE POSITIVE, WHEN SLOTPROPS ARE SET
            throw new Error('Label is missing. Set the label by using the default slot.')
        } else if (this.$slots.hasOwnProperty('default') && this.$slots.default.some(property => property.elm && property.elm.nodeName === 'IMG' && property.elm.attributes.alt.value.trim() === '')) {
            throw new Error('Label is missing. Seems like you are using an image, so make sure to set the alt attribute.')
        } else if (this.$slots.hasOwnProperty('default') && this.$slots.default.every(property => !property.elm && property.text.trim() === '')) {
            throw new Error('Label is missing. Seems like you are trying to hack the component. `null` and empty string is not a label.')
        }
    },
    methods: {
        getInitialDate () {
            if (this.value !== null && this.value !== undefined) {
                return this.normalizeDate(this.value)
            }

            return this.normalizeDate(this.date)
        },
        normalizeDate (value) {
            if (value === null || value === undefined || value === '') {
                return null
            }

            if (value instanceof Date) {
                return isNaN(value.getTime()) ? null : value
            }

            const parsedDate = new Date(value)
            return isNaN(parsedDate.getTime()) ? null : parsedDate
        }
    }
}
</script>

<style lang="scss">
.datepicker {
  width: 100%;
}
.vc-title {
  text-transform: capitalize;
}
.vc-bar,
.vc-highlight {
  background-color: var(--primaryColor) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseDatePicker.vue